import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-laura-dark text-laura-cream/70 py-16 border-t border-laura-wood/30" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-86">
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-87">
            <h2 className="text-3xl font-playfair text-laura-cream mb-4" data-id="element-88">
              El Rincón de Laura
            </h2>
            <p className="text-sm leading-relaxed max-w-xs" data-id="element-89">
              Restaurante asador tradicional en Villaconejos. Especialistas en
              cordero asado, cochinillo y cocina casera madrileña.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-90">
            <h3 className="text-lg font-bold uppercase tracking-wider text-laura-amber mb-4" data-id="element-91">
              Horarios
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-92">
              <li data-id="element-93">
                <span className="text-laura-cream" data-id="element-94">Lunes a Viernes:</span> Menú
                del día
              </li>
              <li data-id="element-95">
                <span className="text-laura-olive font-bold" data-id="element-96">
                  Miércoles: Cerrado
                </span>
              </li>
              <li data-id="element-97">
                <span className="text-laura-cream" data-id="element-98">Sábado y Domingo:</span>{' '}
                Comidas
              </li>
              <li data-id="element-99">
                <span className="text-laura-cream" data-id="element-100">Viernes y Sábado:</span>{' '}
                Cenas
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-101">
            <h3 className="text-lg font-bold uppercase tracking-wider text-laura-amber mb-4" data-id="element-102">
              Contacto
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-103">
              <li data-id="element-104">Calle Emilio de la Tía Fidela, 2</li>
              <li data-id="element-105">28360 Villaconejos, Madrid</li>
              <li className="pt-2" data-id="element-106">
                <a href="tel:+34660343711" className="hover:text-laura-amber transition-colors" data-id="element-107">
                  +34 660 34 37 11
                </a>
              </li>
              <li data-id="element-108">
                <a href="https://wa.me/34660343711" target="_blank" rel="noopener noreferrer" className="hover:text-laura-amber transition-colors" data-id="element-109">
                  Reservar por WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-laura-wood/30 pt-8 flex flex-col items-center" data-id="element-110">
          <p className="text-xs tracking-wider uppercase mb-4 text-center" data-id="element-111">
            &copy; {currentYear} Restaurante Asador El Rincón de Laura. Todos
            los derechos reservados.
          </p>

          <div className="text-[10px] text-laura-wood/60 text-center max-w-3xl flex flex-wrap justify-center gap-2" data-id="element-112">
            <span data-id="element-113">Asador en Villaconejos</span> |
            <span data-id="element-114">Restaurante en Villaconejos</span> |
            <span data-id="element-115">Cordero asado Madrid</span> |
            <span data-id="element-116">Restaurante cerca de Aranjuez</span> |
            <span data-id="element-117">Restaurante tradicional Madrid</span>
          </div>
        </div>
      </div>
    </footer>;
}